import type { HTMLAttributes, ReactNode } from 'react';
import './cartao.css';

export type VarianteCartao =
  'padrao' | 'arrastavel' | 'escolhivel' | 'interno' | 'folgado' | 'linha';

export type CartaoProps = {
  variante?: VarianteCartao;
  /** Trilho âmbar à esquerda: negócio em risco. */
  risco?: boolean;
  /** Movimento em curso no servidor: esmaece e o cursor vira `progress`. */
  movendo?: boolean;
  /** Só em `escolhivel`: anel roxo. */
  escolhido?: boolean;
  /** O cartão inteiro é o alvo. Exige `rotulo`. */
  aoAbrir?: () => void;
  /** Rótulo do alvo para leitor de tela: "Abrir Corolla Cross XRE 2023". */
  rotulo?: string;
  /**
   * O elemento da casca. O cartão é aparência; a semântica é de quem usa: o
   * do funil é um `article` arrastável, o item da linha do tempo é um `li`, o
   * lado da comparação é um `label` com rádio dentro.
   */
  como?: 'div' | 'article' | 'li' | 'label' | 'form' | 'section';
  /**
   * A classe da TELA que ajusta este cartão no contexto — `admin__bloco`,
   * `admin__form`. Some junto com o cartão.
   *
   * `className` continua fora da API de propósito: com ele, uma tela
   * SUBSTITUIRIA a classe do componente e o cartão sairia sem forma, em
   * silêncio. Isto acrescenta, e é a composição que o desenho do sistema
   * prevê — o que não pode é a tela reescrever o bloco.
   *
   * Para MEDIDA, prefira a variável de instância: uma classe que redeclara
   * `border`, `radius` e `background` é a cópia que este componente existe
   * para acabar.
   */
  parte?: string;
  children?: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, 'className' | 'children'>;

export function Cartao({
  variante = 'padrao',
  risco = false,
  movendo = false,
  escolhido = false,
  aoAbrir,
  rotulo,
  como: Casca = 'div',
  parte,
  children,
  ...resto
}: CartaoProps) {
  const classe = ['cartao', variante === 'padrao' ? null : `cartao--${variante}`, parte]
    .filter(Boolean)
    .join(' ');

  return (
    <Casca
      className={classe}
      data-risco={risco ? 'sim' : undefined}
      data-movendo={movendo ? 'sim' : undefined}
      data-escolhido={escolhido ? 'sim' : undefined}
      {...resto}
    >
      {aoAbrir ? (
        <button className="cartao__botao" type="button" onClick={aoAbrir} aria-label={rotulo}>
          {children}
        </button>
      ) : (
        children
      )}
    </Casca>
  );
}
